export const PAGE_SIZE = 5;

export const TrialState = {
  TRIAL_ENDED: 0,
  TRIAL_ELIGIBLE: 1,
  TRIAL_ONGOING: 2,
};
